/**
 * AnnouncementEventService
 * Service for managing announcement-event associations
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement event CRUD operations
 */
export class AnnouncementEventService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementEventService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementEventService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all events for a specific announcement
     * GET /api/announcement-events/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement events
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all events for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
    /**
     * Get enriched event views for a specific announcement
     * GET /api/announcement-events/by-announcement/{announcementId}/views
     * @param announcementId - Announcement ID
     * @returns Array of announcement event model views
     */
    async getViewsByAnnouncementId(announcementId) {
        const response = await this.getViewsByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get enriched event views for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getViewsByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}/views`);
        return this.http.get(url);
    }
}
AnnouncementEventService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementEventService.BASE_PATH = 'api/announcement-events';
//# sourceMappingURL=AnnouncementEventService.js.map